import provider from '@/api/apollo-client';
import gql from './schemas.gql';

export default function() {
  function save(key, data) {
    localStorage.setItem(`pixel_admin_${key}`, JSON.stringify(data));
  }

  function load(key) {
    const data = localStorage.getItem(`pixel_admin_${key}`);
    if (data) {
      return JSON.parse(data);
    }
    return data;
  }
  return {
    save,
    load
  };
}
